export interface IStateDefinitionOutputDto {
    id: string;
    organizationId?: string;
    name: string;
    color: string;
    icon?: string;
    order: number;
    tripDefinitions?: string[];
}
